import Vue from 'vue'
import Vuex from 'vuex'
import {lang} from './modules/lang.js';
import {alert} from './modules/alert.js';
import {map} from './modules/map.js';
import {customers} from './modules/customers';
import {circle} from './modules/circle';

Vue.use(Vuex)

import {login, logout} from "@/api/api.js"

export default new Vuex.Store({
  state: {
      USER: {
          id: '',
          email: localStorage.getItem('userEmail') || ''
      }
  },
  mutations: {
     SAVE_USER(state, payload) {
        localStorage.userEmail = payload.email
        state.USER = payload
     }
  },
    getters: {
        getUserEmail: state => state.USER.email,
    },
  actions: {
      async login({commit, dispatch}, {email, password, remember_me}) {
          try {
            const response = await login(email, password, remember_me);
            const user = response.data.data.user;
            let jwt = response.data.data.jwt;
            commit('SAVE_USER', user);
            localStorage.jwttoken = jwt;
            return response;
          } catch (error) {
              const err = error.response;
              if(err.data.error && err.data.errors) {
                  if(err.data.errors.email) {
                      dispatch('ADD_ALERT', {type: 'error', text: err.data.errors.email[0]})
                  }
              }
              // handle the error here
          }
      },
      async logout({commit}) {
         commit('SAVE_USER', {});
         return await logout();
      },

  },
  modules: {
    lang,
    alert,
    map,
    customers,
    circle
  }
})
